var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-header"},[_vm._t("default"),_c('u-icon',{staticClass:"pull-right",attrs:{"name":"ellipsis-v","type":"fa","icon-style":"light"}},[_c('dashboard-widget-context-menu',{ref:"context"})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }